import React from "react";

import StarIcon from "assets/icons/star.svg";
import { cn } from "helpers/style";
import styles from "./Rating.module.scss";

type Props = {
  value: number;
  label?: string | number;
  onChange?: (value: number) => void;
  onClick?: (e: any) => void;
  white?: boolean;
  className?: string;
  classNameStar?: string;
  hidden?: boolean;
};

const Rating: React.FC<Props> = ({
  value,
  label,
  white,
  onChange,
  className,
  classNameStar,
  onClick,
  hidden,
}: Props) => {
  if (hidden) return null;
  const clickable = !!onChange;

  return (
    <div
      className={cn([
        styles.rating,
        clickable && styles.ratingClickable,
        !!onClick && styles.ratingPointer,
        className,
      ])}
      onClick={onClick}
    >
      {[1, 2, 3, 4, 5].map((_, index) => (
        <div
          className={cn([
            styles.ratingStar,
            clickable && styles.ratingStarClickable,
            white && styles.ratingStarWhite,
            index + 1 <= Math.round(value) && styles.ratingStarFilled,
            classNameStar,
          ])}
          key={index}
          onClick={() => onChange && onChange(index + 1)}
        >
          <StarIcon />
        </div>
      ))}

      {label && (
        <div
          className={cn([styles.ratingLabel, white && styles.ratingLabelWhite])}
        >
          {label}
        </div>
      )}
    </div>
  );
};

export default Rating;
